import { Track } from '../../../classes/track'
import { removeGarbageFromString } from './remove-garbage'
import { escapeRegex } from '../../regex'

const suffixToReplace: string[] = [
  'club (re)?mix',
  'extended (re)?mix',
  'dance (re)?mix',
  'dubstep (re)?mix',
  'moombahton (re)?mix',
  'bootleg (re)?mix',
  'progressive (re)?mix',
  'house (re)?mix',
  'tech (re)?mix',
  '12 inch (re)?mix',
  '12" (re)?mix',
  '7 inch (re)?mix',
  '7" (re)?mix',
  'bootleg',
  'vocal (re)?mix',
  'instrumental (re)?mix',
  'dub (re)?mix'
]

export function extractRemixer(track: Track, values: any[]): string | null {
  let remixTag: string = values[1]

  let title: string = track.title.trim().normalize()

  const stringsToRemove: string[] = []
  const resultsToIgnore: string[] = []

  if (!title) return null

  remixTag = remixTag.toLowerCase().trim()

  const regex = new RegExp(`\\(([^)]*)${remixTag}\\)`, 'i')

  for (const replaceRegex of suffixToReplace) {
    const regexSuffix = new RegExp(`${replaceRegex}\\)$`, 'i')

    if (regexSuffix.test(title)) {
      title = title.replace(regexSuffix, `${remixTag})`)
    }
  }

  const group = regex.exec(title)

  if (!group) return null

  let remixer: string = group[1].trim()

  for (const s of stringsToRemove) {
    remixer = remixer.replace(new RegExp(s, 'ig'), '')
  }

  if (resultsToIgnore.includes(remixer.toLowerCase())) return null

  remixer = remixer.trim()

  if (!remixer) return track.artist

  return remixer
}

export function removeRemixerFromTitle(track: Track, values: any[]): string | null {
  if (track.remixer && track.title.includes(track.remixer)) {
    const titleWithoutRemixer: string = track.title.replace(new RegExp(`\\(([^)]*)${escapeRegex(track.remixer)}.*?\\)`), '')

    return removeGarbageFromString(titleWithoutRemixer)
  } else {
    return track.title
  }
}

export function findTracksEligibleForRemixerExtraction(tracks: Track[], remixTag: string) {
  remixTag = remixTag.toLowerCase().trim()

  return tracks.filter(t => {
    if (t.remixer || !t.title) return false

    const title = t.title.toLowerCase()

    if (
      title.includes('original mix') ||
      title.includes('(extended mix') ||
      title.includes('(extended remix') ||
      title.includes('(club remix') ||
      title.includes('(dance remix') ||
      title.includes('(dubstep remix') ||
      title.includes('(house remix') ||
      title.includes('(12" remix') ||
      title.includes('(7" remix') ||
      title.includes('(remix)') ||
      title.includes('club mix') ||
      title.includes('(radio edit)') ||
      title.includes('(video edit)')
    ) return false

    if (title.includes(` ${remixTag})`)) return true

    return false
  })
}
